<template>
    <component :is="tag">
        <slot
            :step="step"
            :brief="brief"
            :contact="contact"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-step="patchStep"
            :is-loading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :is-patching-brief="isPatchingBrief"
            :errors="errors"
            :errorMessage="errorMessage"
            :affiliate-links="affiliateLinks"
            :discount-codes="discountCodes"
        />
    </component>
</template>

<script>
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';
    import {NAME_COMPENSATION} from '../../../constants/activation-brief-steps';

    export default {
        name:   'ActivationBriefPaymentsProvider',
        mixins: [
            BaseActivationBriefStepMixin,
        ],
        computed: {
            step() {
                return this.steps[NAME_COMPENSATION];
            },
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadActivationBrief(),
                        this.loadAffiliateLinks(),
                        this.loadDiscountCodes(),
                    ]);
                })
                .then(() => {
                    this.initStep(this.step);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        },
    };
</script>

<style scoped>

</style>
